import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { STRINGS } from "./strings";

const LangContext = createContext(null);

function lookup(obj, path) {
  return path.split(".").reduce((o, k) => (o && o[k] !== undefined ? o[k] : undefined), obj);
}

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("tow-lang") || "en");

  const setLang = useCallback((l) => {
    setLangState(l);
    localStorage.setItem("tow-lang", l);
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (key, vars) => {
      let s = lookup(STRINGS[lang], key) ?? lookup(STRINGS.en, key) ?? key;
      if (vars && typeof s === "string") {
        Object.entries(vars).forEach(([k, v]) => { s = s.replaceAll(`{${k}}`, v); });
      }
      return s;
    },
    [lang]
  );

  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
